import axios from 'axios';
const API = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';

function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return auth.token ? { Authorization: `Bearer ${auth.token}` } : {};
}

export async function listDoneOrders(params = {}) {
  const res = await axios.get(`${API}/ad-tracker/done-orders`, { headers: authHeader(), params });
  return res.data;
}

export async function listFutureOrders() {
  const res = await axios.get(`${API}/ad-tracker/future-orders`, { headers: authHeader() });
  return res.data;
}

export async function getAdsDashboard(params = {}) {
  const res = await axios.get(`${API}/ad-tracker/ads`, { headers: authHeader(), params });
  return res.data;
}

export async function getAdAppointments(tag) {
  const res = await axios.get(`${API}/ad-tracker/ads/appointments`, {
    headers: authHeader(), params: { tag },
  });
  return res.data;
}

export async function listSamplePreviews(params = {}) {
  const res = await axios.get(`${API}/ad-tracker/sample-previews`, { headers: authHeader(), params });
  return res.data;
}
